<template>
    <div class="zfjlmain">
        <div class="sc">
            <van-collapse v-model="activeNames" style="width:100%">
                <van-collapse-item name="1">
                    <template #title>
                        <div>家庭保洁服务</div>
                    </template>
                    <div class="disfc">
                        <span>擦窗</span>
                        <span>扫地</span>
                        <span>拖地</span>
                    </div>
                </van-collapse-item>
                <van-collapse-item name="2">
                    <template #title>
                        <div>家电维修服务</div>
                    </template>
                    <div class="disfc">
                        <span>彩电</span>
                        <span>电冰箱</span>
                        <span>电饭煲</span>
                    </div>
                </van-collapse-item>
                <van-collapse-item name="3">
                    <template #title>
                        <div>家电清洗服务</div>
                    </template>
					<div class="disfc">
					    <span>洗衣机</span>
					    <span>冰箱</span>
					</div>
                </van-collapse-item>
            </van-collapse>
        </div>
    </div>
</template>
<script>
const axios = require('axios');
export default {
    data() {
        return {
            activeNames:[],//地址下拉框的数据绑定
            timelist:['2020年4月'],//地址下拉框的列表
            xqlist:[
                {
                    status:'离开',
                    place:'1号停车场',
                    time:'2020-01-01 12:30',
                    residence:'2小时30分',
                    money:'-￥15'
                },
                {
                    status:'进入',
                    place:'1号停车场',
                    time:'2020-01-01 12:30',
                    residence:'2小时30分',
                    money:'-￥15'
                }
            ],
            zh:false,
            showzuhu:false,
            bt:'',
        }
    },
    mounted() {
        
    },
    watch:{
        
    },
    methods: {
        
    },
}
</script>
<style lang="less" scoped>
.xijie{
    height: 80px;
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    .zi{
        display: flex;
        flex-direction: column;
        
        width: 70%;
        .ziup{
            display: flex;
            align-items: center;
            span{
                margin-left: 10px;
            }
        }
        
    }
    .money{
        position: absolute;
        right: 5%;
    }
}
.disfc{
    display: flex;
    flex-direction: column;
}

    ::-webkit-scrollbar{
        display: none;
    }
    
</style>